// URL-encode spaces so CRA dev-server serves filenames that contain spaces
export const pub = (path) =>
  `${process.env.PUBLIC_URL}/${path.replace(/ /g, '%20')}`;

const AUTO  = 'Automotive dies building category';
const BURN  = 'These are burner making categories';

export const autoImgs   = Array.from({ length: 6 },  (_, i) => pub(`${AUTO}/1 (${i + 1}).jpeg`));
export const burnerImgs = Array.from({ length: 11 }, (_, i) => pub(`${BURN}/2 (${i + 1}).jpeg`));
export const ALL_IMGS   = [...autoImgs, ...burnerImgs];
export const EDM_VIDEO  = pub('Wire EDM.mp4');

/* ─── Premium SVG icon system ─── */
const svgBase = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.75',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function Ico({ name, size = 22 }) {
  const s = { width: size, height: size };
  switch (name) {
    case 'flame': return (
      <svg {...svgBase} {...s}>
        <path d="M12 2C12 2 7 7.5 7 12a5 5 0 0010 0C17 7.5 12 2 12 2z" />
        <path d="M12 12c0 0-2 2-2 3.5a2 2 0 004 0C14 14 12 12 12 12z" />
      </svg>
    );
    case 'zap': return (
      <svg {...svgBase} {...s}>
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    );
    case 'settings': return (
      <svg {...svgBase} {...s}>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
      </svg>
    );
    case 'wrench': return (
      <svg {...svgBase} {...s}>
        <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
      </svg>
    );
    case 'truck': return (
      <svg {...svgBase} {...s}>
        <rect x="1" y="3" width="15" height="13" />
        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    );
    case 'target': return (
      <svg {...svgBase} {...s}>
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    );
    case 'layers': return (
      <svg {...svgBase} {...s}>
        <polygon points="12 2 2 7 12 12 22 7 12 2" />
        <polyline points="2 17 12 22 22 17" />
        <polyline points="2 12 12 17 22 12" />
      </svg>
    );
    case 'gem': return (
      <svg {...svgBase} {...s}>
        <path d="M6 3h12l4 6-10 13L2 9z" />
        <path d="M11 3 8 9l4 13 4-13-3-6" />
        <line x1="2" y1="9" x2="22" y2="9" />
      </svg>
    );
    case 'clock': return (
      <svg {...svgBase} {...s}>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    );
    case 'shield': return (
      <svg {...svgBase} {...s}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    );
    case 'palette': return (
      <svg {...svgBase} {...s}>
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 011.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
        <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
        <circle cx="12.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
        <circle cx="16.5" cy="9.5" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    );
    case 'building': return (
      <svg {...svgBase} {...s}>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="3" y1="15" x2="21" y2="15" />
        <line x1="9" y1="9" x2="9" y2="21" />
        <line x1="15" y1="9" x2="15" y2="21" />
      </svg>
    );
    case 'flask': return (
      <svg {...svgBase} {...s}>
        <path d="M10 2v8L4.72 17.9A2 2 0 006.5 21h11a2 2 0 001.78-2.1L14 10V2" />
        <line x1="8.5" y1="2" x2="15.5" y2="2" />
        <circle cx="9.5" cy="16" r="1" fill="currentColor" stroke="none" />
        <circle cx="13" cy="18" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
    case 'lightbulb': return (
      <svg {...svgBase} {...s}>
        <path d="M9 21h6" />
        <path d="M10 17h4" />
        <path d="M12 3a6 6 0 00-6 6c0 1.3.4 2.5 1.1 3.5C7.7 13.5 8.4 14.2 8.5 15h7c.1-.8.8-1.5 1.4-2.5A6 6 0 0012 3z" />
      </svg>
    );
    case 'microscope': return (
      <svg {...svgBase} {...s}>
        <path d="M6 18h8" />
        <path d="M3 21h18" />
        <circle cx="11" cy="17" r="3" />
        <path d="M11 14V8" />
        <rect x="8" y="2" width="6" height="8" rx="1" />
        <path d="M8 5H6.5a1 1 0 000 2H8" />
      </svg>
    );
    case 'phone': return (
      <svg {...svgBase} {...s}>
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.53 9.11a19.79 19.79 0 01-3.07-8.67A2 2 0 012.48 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.72 6.72l1.78-.78a2 2 0 012.11.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
      </svg>
    );
    case 'mappin': return (
      <svg {...svgBase} {...s}>
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    );
    case 'mail': return (
      <svg {...svgBase} {...s}>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    );
    case 'arrow-right': return (
      <svg {...svgBase} {...s}>
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
      </svg>
    );
    case 'check': return (
      <svg {...svgBase} {...s}>
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
    case 'whatsapp': return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    );
    default: return null;
  }
}
